import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import DemoModeBanner from "@/components/feature/DemoModeBanner";
import MarqueeBar from "@/components/feature/MarqueeBar";
import PopupAdLightbox from "@/components/feature/PopupAdLightbox";

export default function PublicLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Header />
      <DemoModeBanner />
      <main className="flex-1 w-full">
        <MarqueeBar />
        <Outlet />
      </main>
      <Footer />
      <PopupAdLightbox />
    </div>
  );
}